const EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp'] as const;

/**
 * Filenames in the spec are written as `.jpg`, but whoever supplies the assets
 * may hand over `.png` or `.webp`. Rather than making that a blocker, we try
 * every common extension for the same basename and use whichever exists.
 *
 * The requested extension is tried first, so an explicit `.png` costs nothing.
 */
export function imageCandidates(name: string): string[] {
  const dot = name.lastIndexOf('.');
  if (dot === -1) return [name, ...EXTENSIONS.map((ext) => name + ext)];

  const base = name.slice(0, dot);
  const given = name.slice(dot).toLowerCase();

  return [name, ...EXTENSIONS.filter((ext) => ext !== given).map((ext) => base + ext)];
}
